import { imgSbankBgAtm } from "@/shared/assets/img";
import { SBankLogo } from "@/domains/bank/components/BankCard/components/SbankLogo";

export function ATMErrorFallback() {
  return (
    <div
      className="relative overflow-hidden -mr-[3px] w-[900px] h-[720px] flex flex-col p-8 pb-7 m-auto rounded-[1rem] bg-white bg-cover font-tt-norms-pro bg-[top_center]"
      style={{
        backgroundImage: `url(${imgSbankBgAtm})`,
      }}
    >
      <header className="flex items-center justify-between pt-2 pb-8">
        <SBankLogo className="w-[140px]" />
      </header>

      <main className="h-full bg-gradient-to-b from-white to-[#e3f6e6] to-70% text-dark-800 rounded-[1rem] p-7 flex flex-col">
        <div className="text-center">
          <div className="text-2xl font-bold text-red-600 mb-4">Банкомат временно недоступен</div>
          <div className="text-lg text-gray-700 mb-6">
            В настоящее время банкомат находится на техническом обслуживании.
            <br />
            Приносим извинения за временные неудобства.
          </div>

          <ul className="text-sm text-gray-600 space-y-2 list-disc list-inside text-left w-fit m-auto">
            <li>Проверьте работу банкомата через 15-30 минут</li>
            <li>Используйте другие банкоматы сети</li>
            <li>Обратитесь в отделение банка</li>
            <li>Воспользуйтесь мобильным приложением</li>
          </ul>
        </div>
      </main>
    </div>
  );
}
